module.exports = __webpack_public_path__ + "img/bot.26eb0921.svg";